import images from "@/assets/images";
import Button from "@/components/Button";
import React from "react";
import classnames from "classnames";
import { clickGeneralDownload } from "@/report";
import { useAnimationTime } from "@/hooks";
import TiltedCard from "@/components/TiltedCard";
import { getPCDownloaderbyHttpRequest } from "@/api";
import { HUYA as PCDownloaderServant } from "@/assets/jce/PCDownloaderServant";
import { checkRes } from "@/api/_tafFetch";
import Toast from "@/components/Toast";
import { downloadFile, formatTimeStamp } from "@/utils";
import Constants from "@/constants";

interface IWindowMacProps {
  isBigScreen: boolean;
}
const WindowMac: React.FC<IWindowMacProps> = ({ isBigScreen }) => {
  if (isBigScreen)
    return (
      <div className="flex h-full items-center justify-between">
        <Left className="ml-[100px] mr-[6.67vw] shrink-0 u-max-w-[484px]" />
        <Right className="mr-[100px] w-full flex-1" />
      </div>
    );

  return (
    <div className="mt-[48px]">
      <Left className="mb-[40px] ml-[65px]" />
      <div className="mx-[65px]">
        <Right className="w-full min-w-[680px]" />
      </div>
    </div>
  );
};

interface ILeftProps {
  className?: string;
}
const Left: React.FC<ILeftProps> = ({ className }) => {
  const { isAnimationFirst } = useAnimationTime();
  const [GetPCDownloaderbyHttpRequestRsp, setGetPCDownloaderbyHttpRequestRsp] =
    React.useState<null | PCDownloaderServant.GetPCDownloaderbyHttpRequestRsp>(null);
  React.useEffect(() => {
    getPCDownloaderbyHttpRequest({
      sChannel: "official", // 写死
    })
      .then(res => {
        checkRes(res);
        setGetPCDownloaderbyHttpRequestRsp(res);
      })
      .catch(err => {
        Toast.show("获取下载信息失败：" + err.message);
        console.error(err);
      });
  }, []);
  return (
    <div
      className={classnames(
        "content-wrap-animation",
        className,
        !isAnimationFirst && "!ani-delay-0",
      )}
    >
      <div className={classnames("title-animation", !isAnimationFirst && "!ani-delay-0")}>
        <p className="text-[#FFF] max-text-[42px] max-leading-[42px]">虎牙直播客户端</p>
        <p className="mt-[20px] text-[#fff] max-text-[52px] max-leading-[52px]">沉浸享受精彩直播</p>
      </div>

      <div
        className={classnames(
          "version-animation my-[20px] flex items-center text-[#FFFFFF99] max-text-[12px] max-leading-[22px]",
          !isAnimationFirst && "!ani-delay-0",
        )}
      >
        <p className="max-mr-[20px]">
          V{GetPCDownloaderbyHttpRequestRsp?.Version}｜
          {formatTimeStamp(GetPCDownloaderbyHttpRequestRsp?.lLatestUpdateTime || 0, "YYYY/MM/DD")}
        </p>
        <p>运行环境：Windows7 及以上</p>
      </div>
      <div
        className={classnames(
          "download-button-animation flex",
          !isAnimationFirst && "!ani-delay-300",
        )}
      >
        <div className="">
          <Button
            className="bg-primary u-max-w-[232px] u-max-h-[52px]"
            onClick={() => {
              downloadFile(Constants.DOWNLOAD_URL.PC_WIN);
              clickGeneralDownload({
                button_name: "下载Windows版",
                product_name: "0",
              });
            }}
          >
            <div className="flex items-center">
              <img src={images.iconWindow} className="u-max-w-[28px] u-max-h-[28px] max-mr-[8px]" />
              <p className="font-[500] text-[#0B0B0B] max-text-[18px]">下载Windows版</p>
            </div>
          </Button>
          <p
            className="mt-[8px] cursor-pointer text-center text-[#FFE44D] max-text-[12px] max-leading-[22px]"
            onClick={() => {
              downloadFile(Constants.DOWNLOAD_URL.PC_WIN_ARM);
              clickGeneralDownload({
                button_name: "ARM版本下载",
                product_name: "0",
              });
            }}
          >
            ARM版本下载
          </p>
        </div>
        <div>
          <Button
            className="ml-[20px] bg-[#FFFCED] u-max-w-[187px] u-max-h-[52px]"
            onClick={() => {
              downloadFile(Constants.DOWNLOAD_URL.PC_MAC_DMG);
              clickGeneralDownload({
                button_name: "下载Mac版-dmg",
                product_name: "0",
              });
            }}
          >
            <div className="flex items-center">
              <img src={images.iconMac} className="u-max-w-[28px] u-max-h-[28px] max-mr-[8px]" />
              <p className="font-[500] text-[#000] max-text-[18px]">下载Mac版</p>
            </div>
          </Button>
          <p
            className="mt-[8px] cursor-pointer text-center text-[#FFE44D] max-text-[12px] max-leading-[22px]"
            onClick={() => {
              downloadFile(Constants.DOWNLOAD_URL.PC_MAC);
              clickGeneralDownload({
                button_name: "下载Mac版-AppStore",
                product_name: "0",
              });
            }}
          >
            App Store下载
          </p>
        </div>
      </div>
    </div>
  );
};
interface IRightProps {
  className?: string;
}
const Right: React.FC<IRightProps> = ({ className }) => {
  const { isAnimationFirst } = useAnimationTime();
  return (
    <TiltedCard
      className={classnames("product-animation", className, !isAnimationFirst && "!ani-delay-150")}
      imageSrc={images.PC1}
      rotateAmplitude={8}
      scaleOnHover={1.05}
      showMobileWarning={false}
      showTooltip={false}
      displayOverlayContent={false}
    />
  );
};

export default WindowMac;
